import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router'
import { QuotationService } from '../quotation.service'
import { QuotationModel } from '../models/quotation.model'
import { MasterCommonServices } from '../master.common.service'
import { CommonModule } from '@angular/common'
import { Observable, of, switchMap } from 'rxjs'
import { QuotationFields } from '../models/quotation_fields.model'
import { FollowupComponent } from '../viewQuotationDetail/viewQuotationDetailComponents/followup/followup.component'

@Component({
  selector: 'app-view-follow-up-detail',
  standalone: true,
  imports: [CommonModule, FollowupComponent],
  templateUrl: './viewFollowUpDetail.component.html',
  styleUrl: './viewFollowUpDetail.component.css',
})
export class ViewFollowUpDetailComponent implements OnInit {
  masterCommonServices: MasterCommonServices | undefined
  quotationData: QuotationModel | undefined
  clientName: string = ''
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private quotationService: QuotationService,
    private masterCommonService: MasterCommonServices,
  ) {
    this.masterCommonServices = masterCommonService
    // Define the observable that will emit quotation data
  }
  ngOnInit(): void {
    if (this.masterCommonService.isDataLoaded == false) {
      this.masterCommonService.getAllMasters().then((masters) => {})
    }
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id')
      this.quotationService.getQuotationById(Number(id)).subscribe({
        next: (data: QuotationModel) => {
          this.quotationData = data
        },
        error: (error: any) => {},
      })
    })
  }

  redirectToQuotationDetails(): void {
    if (this.quotationData?.quotationFields?.id) {
      const navigationExtras: NavigationExtras = {
        state: {
          mode: 'update',
          quotationFields: JSON.stringify(this.quotationData?.quotationFields),
          quotationItems: JSON.stringify(this.quotationData?.quotationItems),
          quotationTerms: JSON.stringify(this.quotationData?.quotationTerms),
        },
      }
      this.router.navigate(
        ['/viewQuotationDetails', this.quotationData?.quotationFields.id],
        navigationExtras,
      )
    }
  }
}
